import styled from 'styled-components'

import { helpers } from 'styles'

import { Title as DefaultTitle } from 'components/Layout'

export const Title = styled(DefaultTitle)`
	font-size: ${helpers.font.size.subheader};
`
